import { HULLS, type HullId } from "./hull-definitions.js";
export { HULLS, HULL_IDS, type HullId, type HullDefinition } from "./hull-definitions.js";
export type LoadoutId = "assault" | "defensive";
export const WEAPON_IDS = ["pulse", "laser", "missile", "flak", "rail", "ion"] as const;
export type WeaponId = (typeof WEAPON_IDS)[number];
export const MODULE_IDS = [
  "barrier",
  "volley",
  "repair",
  "mine",
  "jammer",
  "interceptor",
  "repair-field",
  "scan",
] as const;
export type ModuleId = (typeof MODULE_IDS)[number];

export interface WeaponDefinition {
  id: WeaponId;
  damage: number;
  cooldown: number;
  range: number;
  speed: number;
}
export interface ModuleDefinition {
  id: ModuleId;
  energy: number;
  cooldown: number;
}
export interface LoadoutDefinition {
  id: LoadoutId;
  hullId: HullId;
  weaponId: WeaponId;
  modules: [ModuleId, ModuleId];
}
export const WEAPONS: Record<WeaponId, WeaponDefinition> = {
  pulse: { id: "pulse", damage: 24, cooldown: 0.5, range: 410, speed: 720 },
  laser: { id: "laser", damage: 13, cooldown: 0.38, range: 570, speed: 1250 },
  missile: { id: "missile", damage: 34, cooldown: 1.1, range: 740, speed: 350 },
  flak: { id: "flak", damage: 7, cooldown: 0.85, range: 280, speed: 650 },
  rail: { id: "rail", damage: 62, cooldown: 1.7, range: 850, speed: 1800 },
  ion: { id: "ion", damage: 18, cooldown: 0.55, range: 480, speed: 800 },
};
export const MODULES: Record<ModuleId, ModuleDefinition> = {
  barrier: { id: "barrier", energy: 35, cooldown: 10 },
  volley: { id: "volley", energy: 35, cooldown: 9 },
  repair: { id: "repair", energy: 45, cooldown: 14 },
  mine: { id: "mine", energy: 25, cooldown: 6 },
  jammer: { id: "jammer", energy: 30, cooldown: 12 },
  interceptor: { id: "interceptor", energy: 25, cooldown: 10 },
  "repair-field": { id: "repair-field", energy: 45, cooldown: 16 },
  scan: { id: "scan", energy: 30, cooldown: 14 },
};
export function moduleEnergyCost(moduleId: ModuleId, hullId: HullId): number {
  return moduleId === "barrier" ? HULLS[hullId].barrierEnergyCost : MODULES[moduleId].energy;
}
export const LOADOUTS: Record<LoadoutId, LoadoutDefinition> = {
  assault: { id: "assault", hullId: "assault", weaponId: "pulse", modules: ["volley", "mine"] },
  defensive: { id: "defensive", hullId: "interceptor", weaponId: "laser", modules: ["barrier", "repair"] },
};

export function defaultSecondaryModule(loadoutId: LoadoutId, primary: ModuleId): ModuleId {
  const defaults = LOADOUTS[loadoutId].modules;
  return defaults[1] === primary ? defaults[0] : defaults[1];
}

export const LAST_SIGNAL = {
  width: 3200,
  height: 2200,
  station: { x: 420, y: 1100, radius: 150 },
  wreck: { x: 1500, y: 1100 },
  transport: { x: 2410, y: 780 },
  cargoCapacity: HULLS.assault.capacity,
  asteroids: [
    { id: "rock-1", x: 950, y: 1040, radius: 50 },
    { id: "rock-2", x: 1190, y: 1430, radius: 64 },
    { id: "rock-3", x: 1720, y: 710, radius: 55 },
    { id: "rock-4", x: 2030, y: 1160, radius: 60 },
    { id: "rock-5", x: 2670, y: 1390, radius: 70 },
    { id: "rock-6", x: 660, y: 630, radius: 45 },
  ],
};
